<template>
	<div class="form-group health-reports-files">
		<error-box v-if="error" :error="error"/>
		<input type="file" id="file" name="file" @change="filesChange($event.target)" ref="input_file" class="input-file">
		<div class="idi-table table-attachments" v-if="attachments.length">
			<div class="idi-header">
				<div class="idi-cell">File</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="attachment in attachments" :key="attachment.id">
				<div class="idi-cell">
					<span>{{ attachment.name }}</span>
				</div>
				<div class="idi-cell align-right no-padding">
					<spinner v-if="!attachment.metadata"/>
					<button-icon-loading v-else @click.native.prevent="downloadAttachment(attachment)" icon="download"/>
					<button-icon-loading @click.native.prevent="deleteAttachment(attachment)" icon="trash" class="btn-delete"/>
				</div>
			</div>
		</div>
		<div v-else class="no-attachments">
			<shape src="/static/svg/files/attachment.svg"/>
			<p>{{ $t('messages.general.no_attachments') }}</p>
		</div>
		<div id="dropzone" ref="dropzone"><div class="message">{{ $t('messages.general.drop_files_here') }}</div></div>
	</div>
</template>

<script>
export default {
	props: [
		'value',
		'user_uid',
		'watch_id',
		'report_id',
		'active'
	],
	data () {
		return {
			error: null,
			uploading: false
		}
	},
	computed: {
		attachments: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	watch: {
		uploading (value) {
			this.$emit('uploading', value)
		}
	},
	methods: {
		filesChange (target) {
			Array.from(Array(target.files.length).keys()).map(i => {
				this.uploadFile(target.files[i])
			})
			target.value = ''
		},
		uploadFile (file) {
			this.uploading = true
			this.$api.files.upload(this, this.user_uid, this.watch_id, file)
				.then(response => {
					this.$log.info('watch healthreports', 'files.upload OK', response)()
					const file = response.body
					this.attachments.push({ name: file.name, file: file.uid, metadata: file })
				}).catch(errors => {
					this.$log.error('watch healthreports', 'files.upload ERROR', errors)()
					this.error = errors
				}).finally(() => {
					this.uploading = false
				})
		},
		deleteAttachment (attachment) {
			if (confirm('Delete?')) {
				this.attachments = this.attachments.filter(e => e !== attachment)
			}
		},
		downloadAttachment (attachment) {
			const file = attachment.file.split('.')
			const file_uid = file[0]
			this.$api.files.get(this, this.user_uid, this.watch_id, file_uid)
				.then(response => {
					this.$log.info('watch healthreports', 'files.get OK', response)()
					var arrayBuffer = response.body
					var blob = new Blob([arrayBuffer], { type: 'application/download' })
					let link = document.createElement('a')
					link.href = window.URL.createObjectURL(blob)
					link.download = attachment.name
					link.click()
				}).catch(errors => {
					this.$log.error('watch healthreports', 'files.get ERROR', errors)()
				})
		},
		showDropZone (e) {
			//console.log('showDropZone', e)
			if (this.active) {
				this.$refs.dropzone.style.visibility = 'visible'
			}
		},
		hideDropZone (e) {
			//console.log('hideDropZone', e)
			this.$refs.dropzone.style.visibility = 'hidden'
		},
		allowDrag (e) {
			//console.log('allowDrag', e)
			if (this.active && true) { //todo: test if item beingdragged is valid
				e.preventDefault()
				e.dataTransfer.dropEffect = 'copy'
			}
		},
		handleDrop (e) {
			//console.log('handleDrop', e)
			e.preventDefault()
			if (this.active) {
				this.hideDropZone()
				let files = e.dataTransfer.files
				for (let i = 0; i < files.length; i++) {
					this.uploadFile(files[i])
				}
			}
		}
	},
	mounted () {
		const dropzone = this.$refs.dropzone
		window.addEventListener('dragenter', this.showDropZone)
		dropzone.addEventListener('dragenter', this.allowDrag)
		dropzone.addEventListener('dragover', this.allowDrag)
		dropzone.addEventListener('dragleave', this.hideDropZone)
		dropzone.addEventListener('drop', this.handleDrop)
	},
	beforeDestroy () {
		const dropzone = this.$refs.dropzone
		window.removeEventListener('dragenter', this.showDropZone)
		dropzone.removeEventListener('dragenter', this.allowDrag)
		dropzone.removeEventListener('dragover', this.allowDrag)
		dropzone.removeEventListener('dragleave', this.hideDropZone)
		dropzone.removeEventListener('drop', this.handleDrop)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/healthreports/HealthReportFileUpload.vue